import { PolarisClient } from "@digiits-agency/polaris-sdk";
import { tokenStorage } from "@opero/shared";

export const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3500";

export const polaris = new PolarisClient({
  baseUrl: API_URL,
  getToken: () => tokenStorage.getToken(),
  productSlug: "opero",
});

export const APP_URL = import.meta.env.VITE_APP_URL || "http://localhost:5192";
